import unparkRoutes from './routes'

/* @ngInject */
const unparkCtrl = (
  $scope,
  $state,
  valueHandler,
  $$wagon,
  $$train,
  toaster,
  $$railway
) => {
  $scope.$$wagon = $$wagon
  $scope.$$train = $$train
  $scope.$$railway = $$railway

  $scope.goToCreateTrain = () => {
    $state.go(unparkRoutes.createTrain.path)
  }

  $scope.goToReport = () => {
    $state.go(unparkRoutes.report.path)
  }

  $scope.goToSelectWagons = () => {
    $$wagon.data.myWagonIds.splice(0, $$wagon.data.myWagonIds.length)
    $$wagon.data.mySearchedWagons.splice(0, $$wagon.data.mySearchedWagons.length)
    $state.go(unparkRoutes.selectWagons.path)
  }

  $scope.$watch('$$railway.data.myDepartureRailway.id', async (newValue, oldValue) => {
    if (newValue !== oldValue) {
      if (valueHandler.isId(newValue)) {
        $$wagon.data.mySearchedWagons = await $$wagon.request.getByRailway(newValue)
        if (!$$wagon.data.mySearchedWagons.length) {
          toaster.message($$wagon.labels.log.search.noResultOnRailway, 'orange')
        }
      } else {
        $$wagon.data.mySearchedWagons = []
      }
    } else {
      if (valueHandler.isId(newValue) && !$$wagon.data.mySearchedWagons.length) {
        $$wagon.data.mySearchedWagons = await $$wagon.request.getByRailway(newValue)
      }
    }
  })

  $scope.unpark = async (_wagonIds, _train) => {
    const formattedTrain = $$train.format.server(_train)
    formattedTrain.arrival = false
    formattedTrain.id = null

    try {
      const response = await $$train.request.getByQuickSearch(formattedTrain)
      const trains = response.trains
      if (trains.length === 1) {
        const train = trains[0]
        formattedTrain.id = train.id
      } else {
        const response = await $$train.request.save(formattedTrain)
        formattedTrain.id = response.id
      }

      unpark(_wagonIds, formattedTrain.id)
    } catch (error) {
      toaster.error(error)
    }
  }

  const unpark = async (_wagonIds, _trainId) => {
    try {
      const message = await $$wagon.request.unpark(_wagonIds, _trainId)
      $$train.data.myTrain = await $$train.request.getById(_trainId)
      $$wagon.data.myUnparkedWagons = await $$train.request.getWagons(_trainId)
      toaster.message(message)
      $scope.goToReport()
    } catch (error) {
      toaster.error(error)
    }
  }
}

export default unparkCtrl



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/unpark/unpark.controller.js